/**
 * @author 徐凌志
 * @description
 * 给当前应用添加唯一全局 cursor 状态，效果可以应用页顶部参照删除应用的操作
 * warn 需与 commone.less 里的样式同步！
 * @example
 * const currentCursor = globalCursor('wait') // 开启转圈
 * do something...
 * currentCursor.remove() // 停止转圈
 */
const prefix = 'global-cursor';
let currentCursor = null;
export default function globalCursor(type) {
    // 确保当前只有一个 cursor 状态
    if (currentCursor) {
        remove();
    }
    currentCursor = type;
    document.body.classList.add(`${prefix}-${currentCursor}`);
    // 复用函数
    function remove() {
        if (currentCursor) {
            document.body.classList.remove(`${prefix}-${currentCursor}`);
            currentCursor = null;
        }
    }
    return {
        remove,
    };
}
